// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"MenuButton_menuButton__xGTxW"};